<template>
  <div ref="mapContainer" id="google-map">
    <gmap-map
      :zoom="3"
      :center="center"
      ref="gmap"
      style="width: 100%; height: 100%;"
      :options="mapOptions"
    >
      <gmap-info-window 
        v-for="marker in locationMarkers"
        :key="marker.id + '-info'"
        :options="infoOptions" 
        :position="marker.position" 
        :opened="marker.opened" 
        @closeclick="marker.opened = false"
      >
        <div class="info-window-content">
          <div class="header">
            <h3 class="facility-name">{{ marker.facility_name }}</h3>
          </div>
          <img :src="marker.image" alt="Facility Image" class="facility-image"/>
          <table class="facility-info-table">
            <tr><th>Facility Type</th><td>{{marker.facility_type}}</td></tr>
            <tr><th>Address</th><td>{{marker.street_address}}</td></tr>
            <tr><th>Organization</th><td>{{marker.organization_id}}</td></tr>
            <tr><th>GLN</th><td>{{marker.facility_id}}</td></tr>
            <tr><th>Facility Code</th><td>{{marker.facility_code}}</td></tr>
          </table>
        </div>
      </gmap-info-window>
      <gmap-marker
        v-for="marker in locationMarkers"
        :key="marker.id"
        :position="marker.position"
        @click="openInfoWindow(marker)"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: "GoogleMap",
  props: {
    mapHeight: {
      type: Number,
      default: 600
    },
    markers: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    mapHeight(newHeight) {
      this.setMapHeight(newHeight);
    },
    markers(newMarkers) {
      this.animateMarkers(newMarkers);
    }
  },
  mounted() {
    this.setMapHeight(this.mapHeight);
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    setMapHeight(height) {
      const mapContainer = this.$refs.mapContainer;
      if (mapContainer) {
        mapContainer.style.height = `${height}px`;
        this.resizeMap();
      }
    },
    handleResize() {
      this.closeAllInfoWindows();
      this.resizeMap();
    },
    resizeMap() {
      if (this.$refs.gmap && this.$refs.gmap.$mapObject) {
        google.maps.event.trigger(this.$refs.gmap.$mapObject, 'resize');
        // this.$refs.gmap.$mapObject.setCenter(this.center);
      }
    },
    // openInfoWindow(marker) {
    //   this.closeAllInfoWindows();
    //   marker.opened = true;
    //   this.center = marker.position;
    // },
    openInfoWindow(marker) {
      this.closeAllInfoWindows();
      marker.opened = true;

      this.$nextTick(() => {
        const gmap = this.$refs.gmap.$mapObject;
        // const infowindow = this.$refs.gmap.$children.find(child => child.$el.classList.contains('gm-style-iw'));
        const mapBounds = gmap.getBounds();
        const infowindowPos = marker.position;
        
        const padding = 40; // 맵 가장자리로부터의 여유 공간 (픽셀 단위)
        const latLngBounds = new google.maps.LatLngBounds(
          new google.maps.LatLng(mapBounds.getSouthWest().lat() + padding / gmap.getDiv().clientHeight * gmap.getBounds().toSpan().lat(), mapBounds.getSouthWest().lng() + padding / gmap.getDiv().clientWidth * gmap.getBounds().toSpan().lng()),
          new google.maps.LatLng(mapBounds.getNorthEast().lat() - padding / gmap.getDiv().clientHeight * gmap.getBounds().toSpan().lat(), mapBounds.getNorthEast().lng() - padding / gmap.getDiv().clientWidth * gmap.getBounds().toSpan().lng())
        );

        if (!latLngBounds.contains(infowindowPos)) {
          gmap.setCenter(infowindowPos);
        }
      });

      this.center = marker.position;
    },

    closeAllInfoWindows() {
      this.locationMarkers.forEach(marker => {
        marker.opened = false;
      });
    },
    animateMarkers(newMarkers) {
      this.locationMarkers = [];
      let index = 0;
      const addMarker = () => {
        if (index < newMarkers.length) {
          this.locationMarkers.push(newMarkers[index]);
          this.openInfoWindow(newMarkers[index])
          // this.$refs.gmap.$mapObject.setCenter(newMarkers[index].position);
          index++;
          setTimeout(addMarker, 2000);
          
        } else {
          this.resizeMap();
        }
      };
      addMarker();
    }
  },
  data() {
    return {
      center: { lat: 37.3661361, lng: 127.106617 },
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      mapOptions: {
        styles: [
          {
            "featureType": "poi",
            "stylers": [{ "visibility": "off" }]
          },
          {
            "featureType": "transit",
            "stylers": [{ "visibility": "off" }]
          },
          {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [{ "visibility": "off" }]
          },
          {
            "featureType": "landscape",
            "stylers": [{ "color": "#f2f2f2" }]
          },
          {
            "featureType": "water",
            "stylers": [{ "color": "#b9d3c2" }]
          },
          {
            "elementType": "labels.text.fill",
            "stylers": [{ "color": "#746855" }]
          },
          {
            "elementType": "labels.text.stroke",
            "stylers": [{ "color": "#f2f2f2" }]
          },
          {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [{ "color": "#ae9e90" }]
          },
          {
            "featureType": "administrative.locality",
            "elementType": "labels.text.fill",
            "stylers": [{ "color": "#d59563" }]
          }
        ],
        gestureHandling: 'auto',
        gestureHandling: 'auto',
        disableDefaultUI: true, // Disables the default UI controls (including the man icon)
        zoomControl: true, // Enable zoom control
      },
      locationMarkers: []
    };
  }
};
</script>

<style scoped>
#google-map {
  width: 100%;
  height: 100vh;
}

.info-window-content {
  font-family: Arial, sans-serif;
  max-width: 620px;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.facility-name {
  font-size: 16px;
  margin: 0;
  color: #000;
}

.stars {
  font-size: 16px;
  color: #f0c040;
}

.facility-image {
  width: 100%;
  height: auto;
  margin-top: 10px;
  border-radius: 5px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
}

.facility-info-table {
  width: 100%;
  margin-top: 10px;
  border-collapse: collapse;
}

.facility-info-table th,
.facility-info-table td {
  padding: 4px 6px;
  font-size: 14px;
  vertical-align: top;
}

.facility-info-table th {
  text-align: left;
  color: #555;
  font-weight: bold;
  width: 40%;
}

.facility-info-table td {
  text-align: left;
  color: #333;
}

.facility-info-table tr:not(:last-child) td {
  border-bottom: 1px solid #ddd;
}
</style>
